<template>
  <a-drawer :title="`表单归类-${form.name}`" :maskClosable="true" width="100%" placement="right" :closable="true"
    @close="close" :visible="visible">

    <a-row :gutter="12">
      <a-col :span="16">
        <div style="margin-bottom: 10px">
          <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
          <a-button @click="handleAddMy" type="primary" icon="plus" style="float: right;">新增</a-button>
        </div>

        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
            :pagination="ipagination" :loading="loading" class="j-table-force-nowrap" @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handleEditMy(record)">编辑</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>

          </a-table>
        </div>
      </a-col>
      <a-col :span="8">
        <a-spin :spinning="confirmLoading">
          <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 18 }, }"
            ref="ruleForm" :rules="rules">
            <!-- <a-form-model-item
              label="ID">
              <a-input  readOnly v-model="model.id" />
            </a-form-model-item> -->
            <a-form-model-item label="模块类型" prop="type">
              <a-select placeholder="请选择模块类型" v-model="model.type" @change="moduleTypeChange">
                <a-select-option :value='item.value' :key="item.value" v-for="item in typeList">{{ item.text
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item prop="moduleId" label="模块名称" v-show="isVisible">
              <a-select placeholder="请选择模块" v-model="model.moduleId" showSearch :filterOption="filterOption"
                @change="moduleChange">
                <a-select-option :value="item.id" v-for="(item, index) in moduleList" :key="index">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="科室" prop="deptId">
              <a-select placeholder="请选择科室" v-model="model.deptId" showSearch :filterOption="filterOption"
                @change="deptChange">
                <a-select-option :value="item.id" v-for="(item, index) in deptList" :key="index">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="亚专业" prop="submajorId">
              <a-select placeholder="请选择亚专业" v-model="model.submajorId" showSearch :filterOption="filterOption"
                @change="subMajorChange">
                <a-select-option :value="item.id" v-for="(item, index) in subMajorList" :key="index">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="病种" prop="diseaseId">
              <a-select placeholder="请选择病种" v-model="model.diseaseId" showSearch :filterOption="filterOption"
                @change="diseaseChange">
                <a-select-option :value="item.id" v-for="(item, index) in diseaseList" :key="index">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="推荐值" prop="recommend">
              <a-input-number v-model="model.recommend" :min="0" :precision="0" style="width: 100%" />
            </a-form-model-item>
            <a-form-model-item prop="periodIdList" label="推荐周期">
              <a-select placeholder="请选择周期" v-model="model.periodIdList" mode="multiple" showSearch
                :filterOption="filterOption">
                <a-select-option :value="item.id" v-for="(item, index) in periodList" :key="index">{{ item.periodName
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item prop="recommendReason" label="推荐理由">
              <a-textarea :rows="10" placeholder="请输入推荐理由" v-model="model.recommendReason" />
            </a-form-model-item>
            <div style="text-align: right">
              <a-button type="primary" :loading="confirmLoading" style="margin-left: 30px"
                @click="handleSubmit">保存</a-button>
            </div>
          </a-form-model>
        </a-spin>
      </a-col>
    </a-row>
  </a-drawer>
</template>

<script>
import '@assets/less/TableExpand.less'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { putAction, getAction, postAction } from '@api/manage'
import { elementTypeData } from '@/constants/project'
import baseRules from '@/constants/baseRules'

export default {
  name: "TempConfigFormGroup",
  mixins: [JeecgListMixin],
  components: {
  },
  data() {
    return {
      isVisible: false,
      description: '项目配置-知识库-表单元素管理页面',
      form: {},
      model: {},
      rules: {
        number: [{}],
        type: [baseRules.required],
        moduleId: [baseRules.required],
        periodIdList: [baseRules.requiredChange],
        deptId: [baseRules.required],
        submajorId: [baseRules.required],
        diseaseId: [baseRules.required],
        recommend: [baseRules.required],
        recommendReason: [baseRules.required],
      },
      typeList: [
        { text: '通用模块', value: '1' },
        { text: '专病模块', value: '2' },
      ],
      moduleList: [],
      diseaseList: [],
      subMajorList: [],
      deptList: [],
      periodList: [],
      confirmLoading: false,
      visible: false,
      disableMixinCreated: true,
      // 表头
      columns: [
        {
          title: '模块名称',
          align: "left",
          width: 200,
          dataIndex: 'moduleName',
          customRender: (text, record, index) => {
            if (record.moduleId && record.moduleId === '0') {
              return '所有模块'
            } else {
              return record.moduleName
            }
          },
        },
        // {
        //   title: '模块类型',
        //   width:100,
        //   align:"center",
        //   dataIndex: 'number'
        // },
        {
          title: '科室',
          align: "center",
          width: 100,
          dataIndex: 'deptName',
          customRender: (text, record, index) => {
            if (record.deptId && record.deptId === '0') {
              return '所有科室'
            } else {
              return record.deptName
            }
          },
        },
        {
          title: '亚专业',
          width: 150,
          align: "center",
          dataIndex: 'submajorName',
          customRender: (text, record, index) => {
            if (record.submajorId && record.submajorId === '0') {
              return '所有亚专业'
            } else {
              return record.submajorName
            }
          },
        },
        {
          title: '病种',
          align: "center",
          width: 150,
          dataIndex: 'diseaseName',
          customRender: (text, record, index) => {
            if (record.diseaseId && record.diseaseId === '0') {
              return '所有病种'
            } else {
              return record.diseaseName
            }
          },
        },
        {
          title: '推荐周期',
          align: 'center',
          with: 200,
          dataIndex: 'periodIdList',
          customRender: (text, record, index) => {
            let periodNames = ''
            record.periodIdList.forEach(item => {
              periodNames = periodNames + item.periodName + ','
            });
            if(periodNames.length>0){
              periodNames= periodNames.substring(0,periodNames.length-1)
            }
            return periodNames
          },
        },
        {
          title: '推荐值',
          align: "center",
          width: 80,
          dataIndex: 'recommend'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          align: "center",
          scopedSlots: { customRender: 'action' },
        }
      ],
      url: {
        list: "/tempconfig/tempConfigRepository/queryById",
        delete: "/tempconfig/tempConfigRepository/delete",
      },
    }
  },
  computed: {
    currentModuleOption() {
      // 根据value查找对应的选项对象
      return this.moduleList.find(option => option.id === this.model.moduleId);
    },
    currentDeptOption() {
      // 根据value查找对应的选项对象
      return this.deptList.find(option => option.id === this.model.deptId);
    },
    currentSubMajorOption() {
      // 根据value查找对应的选项对象
      return this.subMajorList.find(option => option.id === this.model.submajorId);
    },
    currentDiseaseOption() {
      // 根据value查找对应的选项对象
      return this.diseaseList.find(option => option.id === this.model.diseaseId);
    },
  },
  watch: {
    dataSource() {
      this.handleEditMy(this.model || {})
    }
  },
  mounted() {
  },
  methods: {
    initModules() {
      getAction('/tempconfig/tempConfigModule/list', { type: this.model.type, pageSize: 2000 }).then(res => {
        if (res.success) {
          this.moduleList = res.result.records
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initDisease() {
      getAction('/tempconfig/tempConfigDisease/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.diseaseList = res.result.records
          this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initDept() {
      getAction('/tempconfig/tempConfigDept/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.deptList = res.result.records
          this.deptList.unshift({ "id": "0", "name": "所有科室" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initSubMajor() {
      getAction('/tempconfig/tempConfigSubmajor/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.subMajorList = res.result.records
          this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initPeriod() {
      getAction('/tempconfig/tempConfigPeriod/listAll', {}).then(res => {
        if (res.success) {
          this.periodList = res.result
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },

    moduleTypeChange() {
      if (this.model.type == '2') {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
      this.initModules()
      this.model.moduleId = ''
    },
    moduleChange(vulue, option) {
      if (this.model.type == '1') { //通用模块
        this.model.diseaseId = '0' //默认选择所有病种
        this.model.deptId = '0' //默认选择所有科室
      } else {
        let selectedOption = this.currentModuleOption;
        // console.log("selectedOption"+selectedOption)
        let tempDiseaseList = this.diseaseList.filter(item => item.code == selectedOption.diseaseCode)
        if (tempDiseaseList && tempDiseaseList.length > 0) {
          let currentDisease = tempDiseaseList[0]
          this.model.diseaseId = currentDisease.id
          let depts = currentDisease.deptCodes.split(',')
          let tempDeptList = this.deptList.filter(option => depts.indexOf(option.code) > -1)
          if (tempDeptList && tempDeptList.length == 1) {
            this.model.deptId = tempDeptList[0].id
          } else {
            this.model.deptId = '' //病种关联的科室不唯一，手动选择
          }
        }
      }
    },
    deptChange(vulue, option) {
      // let selectedOption = this.currentDeptOption;
      getAction('/tempconfig/tempConfigSubmajor/queryByDeptId', { id: this.model.deptId }).then(res => {
        if (res.success) {
          this.subMajorList = res.result
          this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
        }
      })
    },
    subMajorChange(vulue, option) {
      // let selectedOption = this.currentSubMajorOption;
      // console.log(selectedOption)
      getAction('/tempconfig/tempConfigDisease/queryByDeptIdAndSubMajorId', { deptId: this.model.deptId, subMajorId: this.model.submajorId }).then(res => {
        if (res.success) {
          this.diseaseList = res.result
          this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
        }
      })

    },
    diseaseChange(vulue, option) {
      if (this.model.type!='1') {
        // let selectedOption = this.currentDiseaseOption;
        if (this.model.diseaseId === "0") {
          this.model.moduleId = "0"
        } else {
          getAction('/tempconfig/tempConfigModule/queryByDiseaseId', { diseaseId: this.model.diseaseId }).then(res => {
            if (res.success) {
              this.model.moduleId = res.result.id
            }
          })
        }
      }
    },
    handleSubmit() {
      const that = this;
      // 触发表单验证
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          //校验字典是否合法
          let formData = JSON.parse(JSON.stringify(this.model));
          let periodList = []
          formData.periodIdList.forEach(id => {
            periodList.push({ "id": id })
          });
          formData.periodIdList = periodList

          that.confirmLoading = true;
          let url = "/tempconfig/tempConfigRepository/add"
          if (formData.id) {
            url = "/tempconfig/tempConfigRepository/edit"
          }
          postAction(url, formData).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.loadData()
              // this.handleCancel()
              that.$emit('reload');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        } else {
          return false;
        }
      })
    },
    handleAddMy() {
      this.handleEditMy({
        formId: this.form.id,
        deptId: '',
        diseaseId: '',
        moduleId: '',
        type: '',
        recommendReason: '',
        recommend: '',
        submajor: '',
        periodIdList: [],
      })
    },
    loadDataCallback() {
      this.handleAddMy()
    },
    handleEditMy(record) {
      const model = JSON.parse(JSON.stringify(record))
      this.model = model
      if (this.model.type == '2') {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }

      this.initModules('')
      // this.initDisease()
      this.initDept()
      this.initPeriod()
      // this.initSubMajor()

      this.deptChange()
      this.subMajorChange()
      // this.diseaseChange()

      if (this.model.id) {
        if (this.model.periodIdList && this.model.periodIdList.length > 0) {
          let periodList = []
          this.model.periodIdList.forEach(item => {
            periodList.push(item.id)
          })
          this.model.periodIdList = periodList
        }
      }
    },
    handleDeleteDictItem(index) {
      this.$confirm({
        title: '提示',
        content: '您确定要删除吗？',
        centered: false,
        onOk: () => {
          this.currentDictItems.splice(index, 1)
        },
      })
    },
    view(form) {
      this.parentDictItems = []
      this.currentDictItems = []
      this.form = form
      this.baseQueryParam = {
        formId: form.id
      }
      this.handleAddMy()
      this.loadData();
      this.visible = true
    },
    close() {
      this.visible = false
      this.$emit('ok')
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>